import { Toaster as Sonner } from 'sonner';

const Toaster = ({ ...props }) => {
  return (
    <Sonner
      className="toaster group"
      toastOptions={{
        style: {
          fontSize: 16,
          fontWeight: 'bold',
          fontFamily: 'Avenir',
          borderColor: 'transparent',
          textAlign: 'center',
          width: '100%'
        }
      }}
      {...props}
    />
  );
};

export { Toaster };
